import { render, staticRenderFns } from "./SmsSendingPopup.vue?vue&type=template&id=2a1e2bff&"
import script from "./SmsSendingPopup.vue?vue&type=script&lang=js&"
export * from "./SmsSendingPopup.vue?vue&type=script&lang=js&"
import style0 from "./SmsSendingPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports